// ============================================================================
// MEAL PLAN ENDPOINTS
// ============================================================================
// Endpoint definitions for Meal Plan module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for meal plan endpoints (matches MealPlanController route)
 */
const BASE_PATH = '/MealPlan';

/**
 * Meal Plan Endpoints
 */
export const mealPlanEndpoints = {
  /**
   * Get all meal plans (paginated)
   * GET /MealPlan
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get meal plan by ID
   * GET /MealPlan/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get meal plan by code
   * GET /MealPlan/code/:code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Create new meal plan
   * POST /MealPlan
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update meal plan
   * PUT /MealPlan/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete meal plan
   * DELETE /MealPlan/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate meal plan code uniqueness
   * GET /MealPlan/validate/code/:code?propertyId=&excludeId=
   */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),

  validateName: (name: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/name/:name`, { name }),
} as const;

/**
 * Export endpoints
 */
export default mealPlanEndpoints;
